import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-create-entity-broker',
  templateUrl: './create-entity-broker.component.html',
  styleUrls: ['./create-entity-broker.component.scss']
})
export class CreateEntityBrokerComponent implements OnInit {
  iframeUrlCreateEntityBroker: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let iframeUrlCreateEntityBrokerRaw = iframeUrl.createBroker.url;
    this.iframeUrlCreateEntityBroker = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlCreateEntityBrokerRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
